import { useState } from "react";
import ToastMessage from "./ToastMessage";
import React from "react";

type ToastOptions = {
    variant?: "success" | "danger" | "warning" | "info";
    duration?: number;
};

export function useToast(position: "top-end" | "top-center" | "bottom-end" | "middle-center" | "bottom-center" = "top-end") {
    const [toasts, setToasts] = useState<
        { id: number; message: React.ReactNode; variant: "success" | "danger" | "warning" | "info"; duration: number }[]
    >([]);

    const showToast = (message: React.ReactNode, options?: ToastOptions) => {
        const id = Date.now();
        const newToast = {
            id,
            message,
            variant: options?.variant ?? "info",
            duration: options?.duration ?? 5000,
        };
        setToasts((prev) => [...prev, newToast]);
    };

    const handleClose = (id: number) => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
    };

    const ToastContainerEl = (
        <ToastMessage toasts={toasts} onClose={handleClose} position={position} />
    );

    return { showToast, ToastContainerEl };
}
